import { PERMISSIONS } from '@vindr/services/constants/permissions.constant';
import { useGlobalContext } from '#contexts/GlobalContext';
import keycloak from '@vindr/services/keycloak';
import { EyeOutlined, SnippetsOutlined } from '@ant-design/icons';
import { LayoutSidebarRightOutlined } from '@vindr/icons';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { ItemType } from '@vindr/ui/src/components/ui/PopupContextMenu/PopupContextMenu';

export const MENU_TYPE = {
  OPEN_VIEWER: 'open',
  OPEN_VIEWER_AND_REPORT: 'open_viewer_and_report',
  OPEN_SPLIT_WINDOW: 'open_split',
  OPEN_SPLIT_WINDOW_AND_REPORT: 'open_split_window_and_report',
  OPEN_REPORT: 'open_report',
};

const useContextMenu = ({ handleContextMenuSelect }): ItemType[] => {
  const { t } = useTranslation('Vindoc');
  const { iframe } = useGlobalContext();
  const [iframeState] = iframe;

  const menuOpenViewer = useMemo(() => {
    if (iframeState?.open) {
      return [
        {
          key: MENU_TYPE.OPEN_SPLIT_WINDOW,
          label: t('Open in Split Window'),
          icon: <LayoutSidebarRightOutlined className="text-3xl" />,
          onClick: (record) => handleContextMenuSelect(MENU_TYPE.OPEN_SPLIT_WINDOW, record),
          disabled: (record) =>
            !record?.order?.study?.study_instance_uid ||
            !keycloak.hasOneOfPerm([PERMISSIONS.page.view_viewer]),
        },
        {
          key: MENU_TYPE.OPEN_SPLIT_WINDOW_AND_REPORT,
          label: t('Open in Split Window and Report'),
          icon: <LayoutSidebarRightOutlined className="text-3xl" />,
          onClick: (record) =>
            handleContextMenuSelect(MENU_TYPE.OPEN_SPLIT_WINDOW_AND_REPORT, record),
          disabled: (record) =>
            !record?.order?.study?.study_instance_uid ||
            !keycloak.hasOneOfPerm([PERMISSIONS.page.view_viewer]),
        },
      ];
    }

    return [
      {
        key: MENU_TYPE.OPEN_VIEWER,
        label: t('Open Viewer'),
        icon: <EyeOutlined className="text-3xl" />,
        onClick: (record) => handleContextMenuSelect(MENU_TYPE.OPEN_VIEWER, record),
        disabled: (record) =>
          !record?.order?.study?.study_instance_uid ||
          !keycloak.hasOneOfPerm([PERMISSIONS.page.view_viewer]),
      },
      {
        key: MENU_TYPE.OPEN_VIEWER_AND_REPORT,
        label: t('Open Viewer and Report'),
        icon: <EyeOutlined className="text-3xl" />,
        onClick: (record) => handleContextMenuSelect(MENU_TYPE.OPEN_VIEWER_AND_REPORT, record),
        disabled: (record) =>
          !record?.order?.study?.study_instance_uid ||
          !keycloak.hasOneOfPerm([PERMISSIONS.page.view_viewer]),
      },
    ];
  }, [handleContextMenuSelect, iframeState?.open, t]);

  return [
    ...menuOpenViewer,
    {
      key: MENU_TYPE.OPEN_REPORT,
      label: t('Open Report'),
      icon: <SnippetsOutlined className="text-3xl" />,
      onClick: (record) => handleContextMenuSelect(MENU_TYPE.OPEN_REPORT, record),
      disabled: !keycloak.hasOneOfPerm([PERMISSIONS.page.view_report]),
    },
  ];
};

export default useContextMenu;
